
import { MapTo } from '@adobe/aem-react-editable-components';
import ConsumerPrivacyEmailForm, { ConsumerPrivacyEmailFormEditConfig } from './ConsumerPrivacyEmailForm';

export default MapTo('cob-corp-acquisition/components/creditonebank/consumer-privacy-email-form')(ConsumerPrivacyEmailForm, ConsumerPrivacyEmailFormEditConfig);
        